(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ch-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('ch-cart-form');
    if (!form) return;

    var busy = false;

    function update(line, quantity) {
      if (busy) return;
      busy = true;
      var items = document.querySelector('.ch-cart__items');
      if (items) items.classList.add('ch-cart__items--loading');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
    }

    document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.dataset.line);
        var input = document.querySelector('[data-qty-input="' + line + '"]');
        var delta = btn.dataset.qtyChange === 'up' ? 1 : -1;
        var qty = Math.max(0, parseInt(input.value || 0) + delta);
        input.value = qty;
        update(line, qty);
      });
    });

    document.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.dataset.qtyInput);
        var qty = Math.max(0, parseInt(input.value) || 0);
        update(line, qty);
      });
    });

    document.querySelectorAll('[data-remove-line]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        update(parseInt(btn.dataset.removeLine), 0);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    // Intercept history.replaceState — Dawn calls this synchronously when a variant is selected,
    // so the URL is already updated by the time our event fires.
    const _origReplace = history.replaceState.bind(history);
    history.replaceState = function (state, title, url) {
      _origReplace(state, title, url);
      if (typeof url === 'string') {
        const variantId = new URL(url, location.href).searchParams.get('variant');
        if (variantId) {
          document.dispatchEvent(new CustomEvent('ch:variant-changed', {
            detail: { variantId: Number(variantId) }
          }));
        }
      }
    };

    function initInstallationNotice(container) {
      const variantSelects = container.querySelector('variant-selects');
      if (!variantSelects) return;

      const servicesScript = variantSelects.querySelector('[data-variant-services]');
      const notice = container.querySelector('.ch-installation-notice');
      if (!servicesScript || !notice) return;

      const servicesMap = JSON.parse(servicesScript.textContent);

      function showForVariant(variantId) {
        const services = servicesMap[variantId] || {};
        notice.hidden = !services.includes_installation;
      }

      document.addEventListener('ch:variant-changed', function (e) {
        showForVariant(e.detail.variantId);
      });

      // Initial state: read from URL param, or fall back to data-selected-variant
      const urlVariantId = Number(new URLSearchParams(location.search).get('variant'));
      if (urlVariantId) {
        showForVariant(urlVariantId);
      } else {
        try {
          const selected = JSON.parse(variantSelects.querySelector('[data-selected-variant]').textContent);
          showForVariant(selected.id);
        } catch (e) {}
      }
    }

    function initInstallationUpsell() {
      document.querySelectorAll('.ch-install-upsell').forEach(function (card) {
        const installVariantId = Number(card.dataset.installVariant);
        const btn = card.querySelector('[data-add-installation]');
        if (!installVariantId || !btn) return;

        btn.addEventListener('click', function () {
          btn.disabled = true;
          const orig = btn.textContent;
          btn.textContent = '...';

          const notificationEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

          var formData = new FormData();
          formData.append('id', installVariantId);
          formData.append('quantity', 1);
          if (notificationEl) {
            formData.append('sections', notificationEl.getSectionsToRender().map(function (s) { return s.id; }));
            formData.append('sections_url', window.location.pathname);
            notificationEl.setActiveElement(btn);
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
            body: formData,
          })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status) throw new Error(data.description);
              btn.textContent = '✓ Dodano';
              if (notificationEl) {
                try {
                  notificationEl.renderContents(data);
                } catch (_) {
                  if (notificationEl.open) notificationEl.open();
                }
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  cartData: data,
                });
              }
            })
            .catch(function () {
              btn.textContent = orig;
              btn.disabled = false;
            });
        });
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ch-pd').forEach(initInstallationNotice);
      initInstallationUpsell();
    });

    // Skeleton loader for product media images
    function markLoaded(img) {
      img.classList.add('ch-loaded');
      var item = img.closest('.product__media-item');
      if (item) item.classList.add('ch-loaded');
    }
    document.querySelectorAll('.ch-pd__media-col .product__media-item .product__media > img').forEach(function(img) {
      if (img.complete && img.naturalWidth > 0) {
        setTimeout(function() { markLoaded(img); }, 350);
      } else {
        img.addEventListener('load', function() { markLoaded(img); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
